export enum videoTypes {
    FETCH_VIDEO_REQUEST = 'FETCH_VIDEO_REQUEST',
    FETCH_VIDEO_BY_ID_REQUEST = 'FETCH_VIDEO_BY_ID_REQUEST',
    EDIT_VIDEO = 'EDIT_VIDEO',
    CREATE_VIDEO_REQUEST = 'CREATE_VIDEO_REQUEST',
    DELETE_VIDEO_REQUEST = 'DELETE_VIDEO_REQUEST',
    SET_VIDEO = 'SET_VIDEO',
    SET_RELATIVE_VIDEO = 'SET_RELATIVE_VIDEO',
}
